import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import CommonProgress from "components/loader/commonProgress";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import {
  mainTheme,
  secondaryTheme,
  secondaryThemeDark,
} from "config/helpers/common_helper";

const getPositionStyles = (position, isMobile) => {
  switch (position) {
    case "top-right":
      return {
        top: 0,
        right: 0,
        transform: isMobile ? "translate(0%, 0%)" : "translate(-10%, 10%)",
      };
    case "top-left":
      return {
        top: 0,
        left: 0,
        transform: isMobile ? "translate(0%, 0%)" : "translate(10%, 10%)",
      };
    case "bottom-right":
      return {
        bottom: 0,
        right: 0,
        transform: isMobile ? "translate(0%, 0%)" : "translate(-10%, -10%)",
      };
    case "bottom-left":
      return {
        bottom: 0,
        left: 0,
        transform: isMobile ? "translate(0%, 0%)" : "translate(10%, -10%)",
      };
    default:
      return {}; // Default position (centered)
  }
};

const Confirmation = (props) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const app = useSelector((state) => state?.app, isEqual);
  const i18n = useTranslation();
  const {
    open = false,
    setOpen,
    callback = new Function(),
    message = "",
    note = "",
    title = `${i18n.t("appointments.ARE_YOU_SURE")}`,
    type = "",
    showCancel = true,
    microphoneInfoJsx = <></>,
    position = "center",
    cancelText = "",
    okText = "",
    closeCallback = new Function(),
    cross = true,
    extraButton = "",
    extraFunction = new Function(),
    loading = false,
    showExitButton = false,
    exitAction = new Function(),
    exitButtonLoading = false,
    cancelFunction = new Function(),
    preventCloseFromBackground = false,
  } = props;

  const handleClose = () => {
    if (closeCallback) {
      closeCallback();
    }
    if (!loading) {
      setOpen(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (preventCloseFromBackground) {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
          }
          if (type == "cancelConfirmation") {
            new Function();
          } else {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          minHeight: "400px",
          margin: isMobile ? "10px" : "0px",
        }}
        PaperProps={{
          style: {
            position: "absolute",
            ...getPositionStyles(position, isMobile),
            borderRadius: "1vw",
            minWidth: isMobile ? "0" : "clamp(27vh, 27vw, 27vw)",
            minHeight: isMobile ? "0" : "auto",
            background:
              app?.theme === "dark" ? secondaryThemeDark : secondaryTheme,
          },
        }}
      >
        <Box sx={{ margin: "0.3vw 0.6vw -1.5vw auto !important" }}>
          {cross ? (
            <IconButton
              onClick={() => {
                if (cancelText === "common.STAY_LOGGED_IN") {
                  cancelFunction();
                } else {
                  handleClose();
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : (
            <div className="p-2"></div>
          )}
        </Box>
        <DialogTitle
          sx={{
            textAlign: "center",
          }}
          id="alert-dialog-title"
        >
          {title}
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            {type == "cancelConfirmation"
              ? `${i18n.t(
                  "common.YOU_HAVE_SOME_UNSAVED_WORK_DO_YOU_STILL_WANT_TO_LEAVE_THE_PAGE"
                )} ?`
              : message}
            <Box>{note && note}</Box>
          </DialogContentText>
          {microphoneInfoJsx}
        </DialogContent>
        <DialogActions
          sx={{
            marginBottom: "1vw",
            justifyContent: "space-evenly",
            ...(isMobile && {
              height: isMobile ? "0" : "50vh",
              marginBottom: "1vw",
              justifyContent: "flex-end",
            }),
          }}
        >
          {type !== "unknown" && showCancel && (
            <Button
              sx={{
                borderColor: app?.theme === "dark" ? "#fff" : "#000",
                color: "inherit",
              }}
              fullWidth
              variant="outlined"
              size="large"
              onClick={() => {
                if (cancelText === "common.STAY_LOGGED_IN") {
                  cancelFunction();
                }
                {
                  handleClose();
                }
              }}
              disabled={loading || exitButtonLoading}
            >
              {type == "cancelConfirmation"
                ? i18n.t("common.GO_BACK")
                : type == "appointmentCancellation"
                ? i18n.t("common.GO_BACK")
                : cancelText
                ? i18n.t(cancelText)
                : i18n.t("common.CANCEL")}
            </Button>
          )}

          {/* {extraButton && (
            <Button
              variant="outlined"
              sx={{
                height: "2.3vw",
                width: "30%",
                
              }}
              onClick={() => {
                extraFunction();
                handleClose();
              }}
            >
              {extraButton}
            </Button>
          )} */}

          <Button
            variant="contained"
            // sx={{ width: extraButton ? "30%" : "40%", height: "2.3vw" }}
            // sx={{
            //   width: extraButton ? "60%" : "40%",
            //   // height: "2.3vw",
            //   // padding: extraButton && "0px",
            // }}
            fullWidth
            size="large"
            onClick={async () => {
              if (type == "unknown") {
                if (!loading) {
                  setOpen(false);
                }
              } else {
                await callback();

                // dispatch(set_isDirty(false));
                if (!loading) {
                  setOpen(false);
                }
              }
            }}
            disabled={loading || exitButtonLoading}
            // sx={{
            //   background:mainTheme,
            //   color:'inherit'
            // }}
          >
            {loading ? (
              <CommonProgress />
            ) : type == "cancelConfirmation" ? (
              i18n.t("common.YES_LEAVE")
            ) : type == "appointmentCancellation" ? (
              i18n.t("common.YES_CANCEL")
            ) : okText ? (
              i18n.t(okText)
            ) : extraButton ? (
              extraButton
            ) : (
              i18n.t("common.OK")
            )}
          </Button>
          {showExitButton && (
            <Button
              onClick={async () => {
                await exitAction();
              }}
              fullWidth
              size="large"
              variant="contained"
              color="error"
              disabled={loading || exitButtonLoading}
            >
              {exitButtonLoading ? <CommonProgress /> : i18n.t("common.EXIT")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default Confirmation;
